import { makeAutoObservable, runInAction } from 'mobx';

export class LoyaltyStore {
  constructor(rootStore) {
    this.rootStore = rootStore;

    this.info = '';
    this.tutorialVideoIframe = '';
    this.displayTutorial = false;
    this.infoDocument = null;
    this.gifts = [];

    makeAutoObservable(this);
  }

  getLoyaltyConfig = async () => {
    const res = await this.rootStore.api.loyalty.getLoyaltyConfig();

    runInAction(() => {
      this.info = res.info;
      this.tutorialVideoIframe = res.tutorial_video_iframe;
      this.displayTutorial = res.display_tutorial;
      this.infoDocument = res.info_document;
    });

    return res;
  };

  getBonusesTransactions = async (params) => {
    const res = await this.rootStore.api.loyalty.getBonusesTransactions(params);

    return res;
  };

  getGifts = async () => {
    const res = await this.rootStore.api.loyalty.getGifts();

    runInAction(() => {
      this.gifts = res;
    });

    return res;
  };

  buyGift = async (params) => {
    const res = await this.rootStore.api.loyalty.buyGift(params);

    return res;
  };
}
